import { MailLinkType } from '@core/api';
import { TranslateService } from '@ngx-translate/core';
import { Icon } from '@shared/enums';

export function fileIcon(name: string): string | null {
  switch (name.split('.').pop().toLowerCase()) {
    case 'pdf':
      return Icon.IC_TWOTONE_PICTURE_AS_PDF;

    case 'png':
    case 'jpg':
    case 'gif':
    case 'jpeg':
      return Icon.IC_TWOTONE_IMAGE;

    case 'txt':
    case 'doc':
    case 'xls':
    case 'docx':
    case 'xlsx':
      return Icon.IC_TWONE_TEXT_SNIPPET;

    default: return null;
  }
}

export function getMailLinkTypeName(mailLinkTypeId: string, translate: TranslateService): string {
  switch (mailLinkTypeId) {
    case MailLinkType.CARD: return translate.instant('GENERAL.MAIL_LINK_TYPE_CARD');
    case MailLinkType.CONTACT: return translate.instant('GENERAL.MAIL_LINK_TYPE_CONTACT');
    case MailLinkType.CUSTOMER: return translate.instant('GENERAL.MAIL_LINK_TYPE_CUSTOMER');
    case MailLinkType.ACTIVITY: return translate.instant('GENERAL.MAIL_LINK_TYPE_ACTIVITY');
    case MailLinkType.LEAD_DRAFT: return translate.instant('GENERAL.MAIL_LINK_TYPE_LEAD_DRAFT');
    case MailLinkType.ASSIGNMENT: return translate.instant('GENERAL.MAIL_LINK_TYPE_ASSIGNMENT');
    case MailLinkType.OPPORTUNITY: return translate.instant('GENERAL.MAIL_LINK_TYPE_OPPORTUNITY');
  }

  return 'N/A';
}
